import { create } from 'apisauce'

import config from '../Config/AppConfig'

const apiSauceClient = create({
  baseURL: config.api.connectedaidc,
  timeout: 60000,
  headers: config.api.apiKey
    ? {
      apikey: config.api.apiKey
    }
    : undefined
})

export default apiSauceClient

export const setToken = token => {
  if (global.sessionStorage) {
    const accessToken = global.sessionStorage.getItem('accessToken')
    apiSauceClient.setHeader('Authorization', `Bearer ${accessToken}`)
  }
}

setToken()
